/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { GeneroOption, GeneroOptions } from 'services/genero';
import InputMask from 'react-input-mask';
import Api from 'services/api';

const EditContactData = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [name, setName] = useState(profile?.name);
  const [email, setEmail] = useState(profile?.email);
  const [cargo, setCargo] = useState('Digite seu cargo');
  const [sexo, setSexo] = useState<Array<GeneroOption>>([]);
  const [celular, setCelular] = useState('');
  const [telefone, setTelefone] = useState('');

  return (
    <div className="container p-4">
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <h2 className="card-title text-center">Editar dados do contato</h2>
              <form>
                <div className="row mt-4">
                  <div className="col-sm-6">
                    <label htmlFor="nome" className="font-weight-bold">
                      Nome:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="nome"
                      placeholder={profile?.name}
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="email" className="font-weight-bold">
                      E-mail:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      placeholder={email}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-6">
                    <label htmlFor="cargo" className="font-weight-bold">
                      Cargo:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="cargo"
                      placeholder={cargo}
                      value={cargo}
                      onChange={(e) => setCargo(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="sexo" className="font-weight-bold">
                      Sexo:
                    </label>
                    <Select
                      name="RegionSearch"
                      value={sexo || ''}
                      onChange={(selected) => {
                        setSexo(selected as any);
                      }}
                      options={GeneroOptions}
                      placeholder="Feminino"
                    />
                  </div>
                </div>
                <div className="row mt-4">
                  <div className="col-sm-6">
                    <label htmlFor="telefone" className="font-weight-bold">
                      Telefone:
                    </label>
                    <InputMask
                      type="text"
                      className="form-control"
                      id="telefone"
                      placeholder="Example input"
                      mask="(99) 9999-9999"
                      value={telefone}
                      onChange={(e) => setTelefone(e.target.value)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <label htmlFor="celular" className="font-weight-bold">
                      Celular:
                    </label>
                    <InputMask
                      type="text"
                      className="form-control"
                      id="celular"
                      placeholder="Example input"
                      mask="(99) 99999-9999"
                      value={celular}
                      onChange={(e) => setCelular(e.target.value)}
                    />
                  </div>
                </div>
              </form>
            </div>
            <div className=" p-2 text-center mb-3">
              <button
                onClick={() =>
                  Api.post('/edit_contact', {
                    name,
                    email,
                    cargo,
                    sexo,
                    celular,
                    telefone,
                  })
                }
                type="button"
                className="btn btn-lg btn-primary btn-submit-modal"
              >
                Enviar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditContactData;
